import { PinnablePopover } from '../PinnablePopover'
import { PreviewCard } from './PreviewCard'
import type { PinnablePopoverProps } from '../PinnablePopover'
import type { PreviewCardProps } from './PreviewCard'

export type HoverPreviewCardProps = PreviewCardProps & Omit<PinnablePopoverProps, 'children'>

/**
 * A `PreviewCard` revealed from a trigger — the common case of `PinnablePopover`. Use
 * `PinnablePopover` directly when the content is not a `PreviewCard`.
 */
export const HoverPreviewCard = ({ trigger, label, placement, onOpenChange, ...cardProps }: HoverPreviewCardProps) => (
  <PinnablePopover trigger={trigger} label={label} placement={placement} onOpenChange={onOpenChange}>
    <PreviewCard {...cardProps} />
  </PinnablePopover>
)
